export const FAQS = [
  {
    q: "Is a handwritten will valid in India?",
    a: "Yes. Under the Indian Succession Act, 1925, a will can be handwritten or typed. It does not need to be on stamp paper. It must, however, be signed by the testator in the presence of two witnesses who also sign it.",
  },
  {
    q: "What happens if I die without a will in India?",
    a: "If you die intestate (without a will), your assets are distributed according to the succession laws applicable to your religion — Hindu Succession Act for Hindus, Sikhs, Buddhists and Jains; Muslim Personal Law for Muslims; Indian Succession Act for Christians and Parsis. Courts decide — not you.",
  },
  {
    q: "Can a Muslim make a will in India?",
    a: "Yes. A Muslim can make a will (called 'Wasiyat') but under Muslim Personal Law can only bequeath up to one-third of their estate to non-heirs without the consent of legal heirs. WillSeva's lawyer review ensures your will complies with the relevant personal law.",
  },
  {
    q: "Do I need to register my will?",
    a: "Registration is not mandatory in India, but strongly recommended. A registered will is harder to challenge. You can register at the sub-registrar's office for a nominal fee. WillSeva can guide you through registration during lawyer review.",
  },
  {
    q: "Is stamp paper required for a will?",
    a: "No. An Indian will does not need to be written on stamp paper. Plain paper with signatures of the testator and two witnesses is sufficient.",
  },
  {
    q: "Can I update or change my will later?",
    a: "Absolutely. You can write a new will at any time — the most recent valid will supersedes all earlier versions. You can also add a 'codicil' (amendment) to an existing will.",
  },
  {
    q: "Who can be a witness to my will?",
    a: "Any adult of sound mind who is not a beneficiary of the will. It is generally safer to choose witnesses who are younger than you, so they are available if the will needs to be proven later.",
  },
  {
    q: "Is the will generated by WillSeva legally enforceable?",
    a: "Yes. The will is professionally structured under the Indian Succession Act, 1925 using our deterministic drafting engine and standard legal clauses. Legal enforceability, however, also depends on proper execution — signing in the presence of two witnesses. For complex estates, the Lawyer Review add-on is strongly recommended.",
  },
];
